<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- alert -->
    <div>
      <v-alert
        :type="alert_type"
        :model-value="alert"
        :value="alert"
        transition="scale-transition"
        >{{ alert_message }}</v-alert
      >
    </div>
    <!-- Approve / reject popup -->
    <v-dialog v-model="confirmationModelDelete" persistent max-width="450px">
      <v-card class="v-card-100">
        <v-card-title class="d-flex align-center">
          <span>Confirmation</span>
          <v-spacer></v-spacer>
          <v-btn variant="solo" icon @click="confirmationModelDelete = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="text-center pt-6">
          <span> {{ accessMessage }} </span>
        </v-card-text>
        <v-card-actions center>
          <v-spacer></v-spacer>
          <v-btn size="small" color="primary" class="text-none" variant="flat" @click="confirmedFunc()">Confirm</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--  Success messeage popup -->
    <v-row justify="center">
      <v-dialog v-model="successPopUp" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="successPopUp = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ successmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="afterClickOkLoadData"
              >Ok</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Tab header section -->
    <div>
      <HeaderComponent :headerTitle="headerText" />
    </div>
    <!-- search action and filter -->
    <v-card-title class="action-style pb-0">
      <v-row class="ma-3 mb-0">
          <v-autocomplete 
            v-model="select_field" 
            :items="select_field_items" 
            label="Select Field" 
            variant="outlined" 
            style="max-width: 158px;"
            class="mr-4"> 
          </v-autocomplete>
          <v-text-field
            color="primary"
            prepend-inner-icon="mdi-magnify"
            v-model="pending_return_search"
            v-no-edge-space
            label="Search"
            style="max-width: 300px"
            variant="outlined"
            :disabled="!select_field"
            v-on:keyup.enter="loadData()"
          ></v-text-field>
        <v-spacer></v-spacer>
        <!-- <v-card-actions style="margin-bottom: 10px">
          <v-btn
            class="mr-2 text-none"
            variant="flat"
            size="x-large"
            color="green"
            :disabled="selected.length == 0"
            @click="approveItems()"
            >Approve</v-btn
          >
          <v-btn
            class="mr-2 text-none"
            variant="flat"
            size="x-large"
            color="red"
            :disabled="selected.length == 0"
            @click="rejectItems()"
            >Reject</v-btn
          >
        </v-card-actions> -->
        <!-- filter -->
        <!-- <v-expansion-panels
          class="custom-control_outlined m-0 pt-0"
          ref="filterPopupRef"
          readonly
          style="max-width: 300px; margin-bottom: 18px; height: 52px"
        >
          <v-expansion-panel variant="outlined" @click="handlefilterPopup">
            <v-expansion-panel-title
              >Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels> -->
    </v-row>
    </v-card-title>
    <!-- table content -->
    <v-layout column>
    <v-container fluid class="overflow-y-auto dynamic-height-dis-card" v-if="table_data.length > 0">
      <v-row class="custom-card-row pt-4">
        <div v-for="item in table_data" :key="item.id" class="custom-card-wrapper pb-2">
          <v-card class="rounded-card pt-2 ma-0" :elevation="4">
            <v-card-text class="pb-0 text-center">
              <v-tooltip v-if="item.type_of_approval.length > 20" location="bottom">
                <template v-slot:activator="{ props }">
                  <div v-bind="props" class="font-weight-bold ellipsis">
                    {{ item.type_of_approval.substring(0, 20) + '...' }}
                  </div>
                </template>
                <span>{{ item.type_of_approval }}</span>
              </v-tooltip>
              <div v-else class="font-weight-bold">{{ item.type_of_approval }}</div>
              <div class="text-center mt-3 font-weight-bold ageing-text">
                {{ item.request_count }}
              </div>
            </v-card-text>
            <v-card-actions class="pa-0 justify-center d-flex" style="background-color: #EEEEEE;">
              <v-btn small class="text-none font-weight-bold" style="color: #003C9E; cursor: pointer; text-decoration: none; font-size: 14px;" @click="viewApprovalLink(item)">
                View
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-row>
    </v-container>
  </v-layout>

     <PaginationComponent
            :pageSize="pageSize"
            :pageSizes="pageSizes"
            :totalCount="totalCount"
            :selected="selected"
            :page="page"
            :totalPages="totalPages"
            @update:pageSize="handlePageSizeChange"
            @update:page="handlePageChange"
            class="mt-2 mb-2"
        />
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog
        content-class="filter-putaway"
        v-model="filterPopup"
        persistent
        max-width="375px"
      >
        <v-card>
          <v-card-actions>
            <!-- <v-text-field prepend-inner-icon="mdi-magnify" v-model="statuss" label="status" outlined class="ma-2" style="max-width: 350px;"></v-text-field> -->
            <v-combobox
              color="primary"
              v-model="statuss"
              :items="filter_status"
              item-title="name"
              item-value="id"
              label="Status"
              style="width: 300px !important"
              variant="outlined"
            ></v-combobox>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" color="normal" @click="closefilter()" class="text-none" variant="outlined"
              >Cancel</v-btn
            >
            <v-btn
              size="small"
              color="primary"
              @click="applyFilters()"
              class="text-none"
              :disabled="this.statuss.length == 0"
              variant="flat"
              >Apply Filter(S)</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../../commoncomponents/HeaderComponent";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import { moduleAccessFunc,module_that_allowed,signout } from '@/backend/axios/moduleAccess';
export default {
    data() {
        return {
            headerText: "Pending Approval",
            search: "",
            select_field: null,
            select_field_items: ["Approval ID"],
            pending_return_search: "",
            loading: false,            
            
            headers: [
                      { title: "Approval ID", key: "approval_id", align: "start", sortable: false,},
                      { title: "Approval Req Date", key: "approval_request_date" },
                      { title: "Initiator/Approver", key: "initiator"},
                      { title: "Type Of Approval", key: "type_of_approval" },
                      { title: "Ageing", key: "ageing" },
                      { title: "Approval Link", key: "approval_link" },
                    ],
            filterPopup :  false ,
            table_data: [],
            confirmationModelDelete : false,
            statuss : [],
            filter_status:[
            {
                "name":"Excess",
                "id": "excess"
              },
              {
                "name":"Short",
                "id": "short"
              },
            ],
            gradeSelected : '',
            gradelist : '',
            selected : [],
            totalPages : 1,
            totalCount: '',
            pageSize: defaultPageSize,
            pageSizes: defaultPageSizes,
            page : 1,
            successPopUp : false,
            accessMessage : '',
            acceptOrReject : '',
            successmessage : '',
            alert_type : 'success',
            alert: false,
            alert_message: '',
            crm_ticket_dupl_details:{},
        }
    },

  components: {
    HeaderComponent,
  },
  created() {
    const role = this.$store.state.currentUser.roles[0]
    if(role in module_that_allowed && moduleAccessFunc(role,'Pending Approval')){
      signout()
      return;
    }
    this.$store.commit("setpendingApproval",{
        pending_approval_item : ''
      })
    this.loadData();
  },
  methods: {
    loadData() {
      this.selected = [];
      this.table_data = [];
      this.page = 1
      this.totalPages = 1
      this.getdata();
    },
   getdata() {
        this.loading = true;
        const params = {
          page: this.page,
          per_page: this.pageSize,
          approval_id: this.pending_return_search
        };

        this.$httpSecured
          .get("/api/v1/approval_requests", { params: params })
          .then((response) => {
            if (response.data) {
              this.table_data =  response.data.approval_requests;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.loading = false;
            } else {
              this.loading = false;
            }
          })
          .catch((error) => {
            this.showAlert("error", error.response.data.message);
            this.loading = false;
          });
      },
    handlefilterPopup() {
      document.documentElement.style.setProperty(
        "--dialog-ypos",
        (
          this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40
        ).toString() + "px",
      );
      this.filterPopup = true;
      this.pending_return_search = "";
      this.$httpSecured
        .get("/api/v1/issue_inventories/pending_approvals")
        .then((response) => {
          if (response.data) {
            // this.filter_status = response.data.issue_inventories;
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
          }
        })
        .catch((error) => {
          this.showAlert("error", error.response.data.message);
          this.loading = false;
        });
    },
    closefilter() {
      this.filterPopup = false;
    },
    applyFilters() {
      this.loading = true;
      const params = {
        inventory_statuses: this.statuss.id,
        page: this.page =1,
        per_page: this.pageSize,
      };
      this.$httpSecured
        .get("/api/v1/issue_inventories/pending_approvals", { params })
        .then((response) => {
          if (response.data) {
            this.table_data = response.data.issue_inventories;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.loading = false;
            this.statuss = "";
            this.gradeSelected = "";
            this.selected = [];
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", error.response.data.message);
          this.loading = false;
        });
      this.filterPopup = false;
    },
    rejectItems() {
      this.confirmationModelDelete = true;
      this.acceptOrReject = "rejected";
      this.accessMessage = "Are you sure! You want reject?";
    },
    approveItems() {
      this.confirmationModelDelete = true;
      this.acceptOrReject = "accepted";
      this.accessMessage = "Are you sure! You want Approve?";
    },
    confirmedFunc() {
      const selectedId = this.selected.map((x) => x.id);
      if (this.acceptOrReject == "accepted") {
        this.$httpSecured
          .post("/api/v1/issue_inventories/approve", { ids: selectedId })
          .then((response) => {
            if (response.data) {
              this.successPopUp = true;
              this.confirmationModelDelete = false;
              this.successmessage = response.data.message;
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
            this.loading = false;
          });
      } else if (this.acceptOrReject == "rejected") {
        this.$httpSecured
          .post("/api/v1/issue_inventories/reject", { ids: selectedId })
          .then((response) => {
            if (response.data) {
              this.successPopUp = true;
              this.confirmationModelDelete = false;
              this.successmessage = response.data.message;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.showAlert(
              "error",
              "Something went wrong from Network" + error,
            );
            this.loading = false;
          });
      }
      this.acceptOrReject = "";
    },
    formatinventory(inventory_status) {
      if (inventory_status === "short") {
        return "Short";
      } else if (inventory_status === "excess") {
        return "Excess";
      } else {
        return inventory_status;
      }
    },
    afterClickOkLoadData() {
      this.successPopUp = false;
      this.page = 1;
      this.pending_return_search = "";
      this.getdata();
    },
    handlePageChange(value) {
      this.page = value;
      this.pending_return_search = "";
      this.getdata();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.pending_return_search = "";
      this.getdata();
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    viewApprovalLink(item) {
      if(item.type_of_approval == 'Buyer activation')
        item.type_of_approval = 'Buyer Activation'
        this.$store.commit("setpendingApproval",{
        pending_approval_item : item
      })

      if(item.type_of_approval == 'Delete PRD'){
        this.$store.commit("setActiveTab",{
          active_tab : 'Approval'
        })
        this.$router.push({ name: 'PRD'})
      }
      else if(item.type_of_approval === 'Buyer lot Assign below Reserve Price' || item.type_of_approval === 'Buyer lot Assigned other than highest bidder'){
        this.$router.push({ name : 'liquidationNew', query : { tab : 'Pending_Approval', changed : true }})
      }else if(item.type_of_approval === 'Tour plan'){
        this.$store.commit("resetTourVisits");
        this.$router.push({ name : 'tourVisit', query : { tab : 'Approval_Requests', changed : true }})
      }else 
        this.$router.push({ name: "claimApproval", query : { type_of_approval : item.type_of_approval } });
    },
  },
};
</script>
<style scoped>
.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none;
}

.custom-control_outlined button {
  min-height: 52px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}

.v-dialog:has(.filter-putaway) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}
.green {
  background: #219653;
  color: #fff;
}
.red {
  background: #ec0101;
  color: #fff;
}
.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 272px) !important;
}
.dynamic-height-dis-card {
    height: calc(var(--vh, 1vh) * 100 - 280px) !important;
  }
.custom-card-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 15px;
  --card-width: calc((100% - (15px * 4)) / 5); /* ensures exactly 5 cards per row */
}

.custom-card-wrapper {
  flex: 0 0 var(--card-width);
  box-sizing: border-box;
}

/* Optional responsive tweaks */
@media (max-width: 1600px) {
  .custom-card-row {
    --card-width: calc((100% - (15px * 3)) / 4);
  }
}

@media (max-width: 1200px) {
  .custom-card-row {
    --card-width: calc((100% - (15px * 2)) / 3);
  }
}

@media (max-width: 900px) {
  .custom-card-row {
    --card-width: calc((100% - (15px * 1)) / 2);
  }
}

@media (max-width: 600px) {
  .custom-card-row {
    --card-width: 100%;
  }
}

/* Utility classes */
.ellipsis {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ageing-text {
  font-size: 20px;
  color: #002E87;
}
.rounded-card {
  border-radius: 12px;
  overflow: hidden;
}
</style>
